import React from 'react';
// CSS 加载顺序固定：主题变量 → 奇门样式 → 八字样式 → MeiHua 适配层
import '../features/theme.css';
import '../features/qimen/styles.css';
import '../features/bazi/bazi.css';
import '../features/adapt.css';
// 排盘逻辑与组件保持原样（与 Qi Men 仓库逐字节一致），此处仅接入 MeiHua 布局
import BaziFeature from '../features/bazi/BaziPage.jsx';

export const BaziPage: React.FC = () => (
  <div className="mh-scope mh-bazi">
    <BaziFeature />
  </div>
);
